export default __webpack_public_path__ + "static/media/Leggings of Fiendish Invocation.462f0aef.jpg";